import { Tab } from "../helper-classes/Tab";
import {
  ContractTabs,
  ScopeDocumentCondensedTypes
} from "../constants/contract-enums";
import { ContractShowIcons } from "./icon-maps";

export const contractShowTabs = [
  new Tab(
    "scope of work",
    ContractTabs.SCOPE,
    ContractShowIcons[ContractTabs.SCOPE],
    null,
    "contract-scope-of-work"
  ),
  new Tab(
    "procedures",
    ContractTabs.PROCEDURES,
    ContractShowIcons[ContractTabs.PROCEDURES],
    null,
    "contract-procedures"
  ),
  new Tab(
    "contacts",
    ContractTabs.CONTACTS,
    ContractShowIcons[ContractTabs.CONTACTS],
    null,
    "contract-contacts"
  ),
  new Tab(
    "plans",
    ContractTabs.PLANS,
    ContractShowIcons[ContractTabs.PLANS],
    null,
    "contract-plans"
  ),
  new Tab(
    "procurements",
    ContractTabs.PROCUREMENTS,
    ContractShowIcons[ContractTabs.PROCUREMENTS],
    null,
    "contract-procurements"
  ),
  new Tab(
    "job tracking",
    ContractTabs.JOB_TRACKING,
    ContractShowIcons[ContractTabs.JOB_TRACKING],
    null,
    "contract-job-tracking"
  ),
  new Tab(
    "work orders",
    ContractTabs.WORK_ORDERS,
    ContractShowIcons[ContractTabs.WORK_ORDERS],
    null,
    "contract-work-orders"
  ),
  new Tab(
    "notes",
    ContractTabs.NOTES,
    ContractShowIcons[ContractTabs.NOTES],
    null,
    "contract-notes"
  )
];

export const ScopeDocumentTabs = [
  new Tab("design", ScopeDocumentCondensedTypes.DESIGN, undefined, null),
  new Tab(
    "construction",
    ScopeDocumentCondensedTypes.CONSTRUCTION,
    undefined,
    null
  ),
  new Tab(
    "change order",
    ScopeDocumentCondensedTypes.CHANGE_ORDER,
    undefined,
    null
  )
];
